import React, { createContext, useState } from "react";

export const ArticlesContext = createContext();

export const ArticlesProvider = ({ children }) => {
  const [articles, setArticles] = useState([]);
  const [totalCount,setTotalCount] =useState() ;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  return (
    <ArticlesContext.Provider value={{
      articles,
      setArticles,
      totalCount,
      setTotalCount,
      page,
      setPage,
      pageSize,
      setPageSize
    }}>
      {children}
    </ArticlesContext.Provider>
  );
};